module.exports = __webpack_public_path__ + "img/yangzhou.98dd607.png";